var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.833,
    height: 22,
    viewBox: "0 0 17.833 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M16.31,6H19.7a1.121,1.121,0,0,1,1.131,1.111V21.556A1.121,1.121,0,0,1,19.7,22.667H6.131A1.121,1.121,0,0,1,5,21.556V7.111A1.121,1.121,0,0,1,6.131,6H9.524",
    transform: "translate(0 0.333)",
    fill: "none",
    stroke: "#102f74",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M14.655,5.222h0A2.242,2.242,0,0,0,12.393,3h0a2.242,2.242,0,0,0-2.262,2.222h0A1.121,1.121,0,0,0,9,6.333V8.556h6.786V6.333A1.121,1.121,0,0,0,14.655,5.222ZM12.393,17.444V13m2.262,2.222H10.131",
    transform: "translate(0.524 0)",
    fill: "none",
    stroke: "#13b4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.3fc880714db4e5fa4a848041ca368a71.svg";
export { ForwardRef as ReactComponent };